import { Workspace } from '@/api/types';

import { visualTitles } from '../constants/reportVisualTitle';

export const useWorkspaceVisualTitles = (workspacePath: string, workspaceData?: Workspace) => {
  return workspaceData?.slices?.length ? workspaceData.slices : visualTitles[workspacePath] || [];
};
